import { ProjectSubTypeApiModel } from "@/core/models/api/project-sub-type-api-model.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export enum ProjectSubTypeActionTypes {
  LoadProjectSubTypes = 'Load ProjectSubTypes',
  LoadProjectSubTypeSuccess = 'Load ProjectSubType Success',
  LoadProjectSubTypeFail = 'Load ProjectSubType Fail',
  AddProjectSubType = 'Add ProjectSubType',
  AddProjectSubTypeSuccess = 'Add ProjectSubType Success',
  UpsertProjectSubType = 'Upsert ProjectSubType',
  AddProjectSubTypes = 'Add ProjectSubTypes',
  UpsertProjectSubTypes = 'Upsert ProjectSubTypes',
  UpdateProjectSubType = 'Update ProjectSubType',
  UpdateProjectSubTypeSuccess = 'Update ProjectSubType Success',
  UpdateProjectSubTypes = 'Update ProjectSubTypes',
  DeleteProjectSubType = 'Delete ProjectSubType',
  DeleteProjectSubTypes = 'Delete ProjectSubTypes',
  ClearProjectSubTypes = 'Clear ProjectSubTypes'
}

export const ProjectSubTypeActions = createActionGroup({
    source: 'ProjectSubType',
    events: {
        [ProjectSubTypeActionTypes.LoadProjectSubTypes]: emptyProps(),
        [ProjectSubTypeActionTypes.LoadProjectSubTypeSuccess]: props<{ projectSubTypes: ProjectSubTypeApiModel[] }>(),
        [ProjectSubTypeActionTypes.LoadProjectSubTypeFail]: props<{ error: string }>(),
        [ProjectSubTypeActionTypes.AddProjectSubTypeSuccess]: props<{ projectSubType: ProjectSubTypeApiModel }>(),
        [ProjectSubTypeActionTypes.AddProjectSubType]: props<{ projectSubType: ProjectSubTypeApiModel }>(),
        [ProjectSubTypeActionTypes.UpdateProjectSubType]: props<{ projectSubType: ProjectSubTypeApiModel }>(),
        [ProjectSubTypeActionTypes.UpdateProjectSubTypeSuccess]: props<{ projectSubType: ProjectSubTypeApiModel }>(),
        [ProjectSubTypeActionTypes.DeleteProjectSubType]: props<{ projectSubTypeId: number }>(),
        [ProjectSubTypeActionTypes.ClearProjectSubTypes]: emptyProps()
    }
});